const CDN_DOMAIN = process.env.VITE_CDN_DOMAIN;

export const apiGetPreviewUrl = (id: string, height: number): string => {
  return `${CDN_DOMAIN}/public/materialPreviews/${id}/preview.png?height=${height}`;
};
